import React, { memo, useState } from "react";
import PropTypes from "prop-types";
import {
  AsyncTypeahead,
  Menu,
  MenuItem,
  Highlighter,
} from "react-bootstrap-typeahead";
import Axios from "./../../axios";
//#region Slice Imports
import { useSelector, useDispatch } from "react-redux";
import { setSelectedProject } from "./../../Slices/sessionSlice";
//#endregion

// needs to be extracted from sessionSlice
// const candidate = "61dc087d2625b634c8aae6a5";

// import { Menu, MenuItem, Highlighter } from 'react-bootstrap';

function ProjectSearchBar() {
  //#region Store Listeners
  const { selectedProject,sessionUser } = useSelector((state) => state.sessionSlice);
  //#endregion

  const dispatch = useDispatch();

  const [projects, setProjects] = useState([]);
  const [query, setQuery] = useState("");
  const [laoding, setLoading] = useState(false);

  const onChangeHandler = (selected) => {
    console.log("selected project :- ", selected);
    dispatch(setSelectedProject(selected));
  };

  const onSearch = (queryValue) => {
    console.log("search value :- ", queryValue);
    setLoading(true);
    setQuery(queryValue.toLowerCase());
    Axios.get(
      `/api/candidate/search-projects?query=${queryValue}&&user=${sessionUser._id}`
    )
      .then((res) => {
        //destructure data
        const { results } = res.data;
        setProjects(results);
        setLoading(false);
      })
      .catch((err) => {
        console.log("Error :- ", err);
      });
  };
  const RenderMenu = memo((results, menuProps) => {
    if (results.results) {
      return (
        <Menu {...menuProps} id={Math.random()}>
          {results.results.map((result, idx) => {
            const { name } = result;
            return (
              <MenuItem
                key={Math.random()}
                option={result}
                position={idx}
                id={idx}
              >
                <Highlighter search={query}>{`${name}`}</Highlighter>
              </MenuItem>
            );
          })}
        </Menu>
      );
    }

    return <Menu />;
  });

  return (
    <div>
      <AsyncTypeahead
        id="basic-typeahead-single"
        labelKey="name"
        onChange={onChangeHandler}
        isLoading={laoding}
        onSearch={onSearch}
        onInputChange={(val) => {
          console.log("Input change :- ", val);
        }}
        options={projects}
        placeholder="search project..."
        selected={selectedProject}
        minLength={1}
        size="lg"
        renderMenu={(results, menuProps) => (
          <RenderMenu results={results} menuProps={menuProps} />
        )}
      />
    </div>
  );
}

ProjectSearchBar.propTypes = {
  selected: PropTypes.instanceOf(Array).isRequired,
  setSelected: PropTypes.func.isRequired,
  projectListForSearch: PropTypes.instanceOf(Array).isRequired,
};

export default ProjectSearchBar;
